export default __webpack_public_path__ + "assets/images/0ab8e0c772abbb9affc27ffb58d22770.png";